import React, { useState } from "react";
import { Button, Skeleton } from "antd";
import "./UserWiseList.scss";
import AllocationDetailsModal from "../AllocationUserDetailModal/AllocationUserDetailModal";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import { useSelector } from "react-redux";
import { formatCurrency } from "../../../assets/helpers";

const UserWiseList = ({
  portfolio,
  data = [],
  pageSize = 10,
  onRowClick = () => {},
  pointer = false,
  loading,
  handlePaginationChange,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const { format } = useSelector((state) => state.priceFormat);

  const handleViewDetails = (record) => {
    setSelectedUser(record);
    setOpenModal(true);
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : text || "NA",
    },
    {
      title: "User Id",
      dataIndex: "user_id",
      key: "user_id",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : text || "NA",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : text || "NA",
    },
    {
      title: "Team Lead",
      dataIndex: "team_lead",
      key: "team_lead",
      render: (text) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : text?.length > 0 ? (
          text?.join(", ")
        ) : (
          "NA"
        ),
    },
    {
      title: "Supervisor",
      dataIndex: "supervisor",
      key: "supervisor",
      render: (text) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : text?.length > 0 ? (
          text?.join(", ")
        ) : (
          "NA"
        ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : text || "NA",
    },
    {
      title: "Allocation",
      dataIndex: "allocation",
      key: "allocation",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : text || "NA",
    },
    {
      title: "Total POS (₹)",
      dataIndex: "total_pos",
      key: "total_pos",
      render: (text) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          formatCurrency(text, format) || "NA"
        ),
    },
    {
      title: "Recovered (₹)",
      dataIndex: "recovered",
      key: "recovered",
      render: (text) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          formatCurrency(text, format) || "NA"
        ),
    },
    {
      title: "Pending (₹)",
      dataIndex: "pending",
      key: "pending",
      render: (text) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          formatCurrency(text, format) || "NA"
        ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          <Button
            type="default"
            className="view-btn"
            onClick={(e) => {
              e.stopPropagation();
              handleViewDetails(record);
            }}
          >
            View Details
          </Button>
        ),
    },
  ];

  const skeletonData = Array(6).fill({});

  const safeData = loading
    ? skeletonData
    : Array.isArray(data?.results?.results)
      ? data?.results?.results
      : [];

  return (
    <div className="userWiseList">
      <ReusableTable
        columns={columns}
        dataSource={safeData}
        pageSize={pageSize}
        totalItems={data?.count}
        onRowClick={onRowClick}
        pointer={pointer}
        triggerChange={handlePaginationChange}
      />

      <AllocationDetailsModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        user={selectedUser}
        portfolio={portfolio}
      />
    </div>
  );
};

export default UserWiseList;
